/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchedLoyaltyProductViewDto } from './searchedLoyaltyProductViewDto';


export interface GetProductsFromFavoriteCategoriesViewDto { 
    /**
     * Id категории
     */
    categoryId?: string;
    /**
     * Наименование категории
     */
    categoryName?: string;
    /**
     * Список продуктов в категории
     */
    products?: Array<SearchedLoyaltyProductViewDto>;
}

